/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpSharedDealerDetailsHeader_user = {
    readonly canShowSellerName: boolean | null;
    readonly " $refType": "PdpSharedDealerDetailsHeader_user";
};
export type PdpSharedDealerDetailsHeader_user$data = PdpSharedDealerDetailsHeader_user;
export type PdpSharedDealerDetailsHeader_user$key = {
    readonly " $data"?: PdpSharedDealerDetailsHeader_user$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedDealerDetailsHeader_user">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedDealerDetailsHeader_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canShowSellerName",
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};
(node as any).hash = '166cbc5213651741bece2eda9e089072';
export default node;
